import React from 'react';
import { Helmet } from 'react-helmet';
import { Organization } from 'schema-dts';
import { helmetJsonLdProp } from 'react-schemaorg';

const LogoMetaData = () => {
  return(
    <Helmet
      script={[
        helmetJsonLdProp<Organization>({
          "@context": "https://schema.org",
          "@type": "Organization",
          "url": "https://www.xometry.com",
          "logo": "https://www.xometry.com/xometry-logo.png"
        })
      ]}
    />
  )
}

export default LogoMetaData;